module.exports = __webpack_public_path__ + "img/logo2.6f4d1ae8.png";